//TODO : Refactor after ai
export const MAIN_FEATURES = {
  Auth: "auth",
  Dashboard: "dashboard",
  Collection: "collection",
  Home: "home",
  Settings: "settings",
  Objekte: "objekte",
  Baustelle: "baustelle",
} as const;

export type MainFeaturesType =
  (typeof MAIN_FEATURES)[keyof typeof MAIN_FEATURES];
